/** P0：頂層出庫 header 固定 MANUAL；明細行固定 INVENTORY_STOCK。 */
export const STOCK_ISSUE_HEADER_SOURCE_TYPE = 'MANUAL';

export const STOCK_ISSUE_LINE_SOURCE_TYPE = 'INVENTORY_STOCK';
